import { noop } from "lodash";

import type { PreviewComponents } from "../../../types";
import { InstallmentsLines } from "../InstallmentsLines";
import { Lines } from "../Lines";
import { hideWhenItIsFreeTrial } from "./helpers";

export const installmentsVariants: PreviewComponents = [
  [InstallmentsLines.TodayPaymentLine, noop],
  [Lines.FreeTrialLine, noop],
  [Lines.SubtotalLine, hideWhenItIsFreeTrial],
  [Lines.DiscountLine, hideWhenItIsFreeTrial],
  [Lines.TaxLine, hideWhenItIsFreeTrial],
  [Lines.EndingBalanceLine, hideWhenItIsFreeTrial],
  [Lines.PaidTrialLine, noop],
  [InstallmentsLines.TotalDueTodayLine, noop],
];
